import React, { Component } from 'react'
import EstimationActions from '../libs/EstimationActions'
import Utils from '../libs/Utils'
import OneLineEditor from '../components/OneLineEditor'
import StyleCompanyUser from '../style/StyleCompanyUser'

class LaborCostPrintTab extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation(),
      isEditable: this.props.isEditable,
      listener: null
    }
  }
  render () {
    const headerTable =
      (
        <div>
          <table style={StyleCompanyUser.printPageArea.laborview.borderNone}>
            <thead>
              <tr>
                <th style={StyleCompanyUser.printPageArea.laborview.titleArea.title1} />
                <th style={StyleCompanyUser.printPageArea.laborview.titleArea.title2} />
                <th style={StyleCompanyUser.printPageArea.laborview.titleArea.title3} />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={StyleCompanyUser.printPageArea.laborview.borderNone}>型枠大工</td>
                <td style={StyleCompanyUser.printPageArea.laborview.borderNone}>型枠解体工</td>
                <td style={StyleCompanyUser.printPageArea.laborview.borderNone}>法定福利費</td>
              </tr>
            </tbody>
          </table>
        </div>
      )

    const inputStyle = {
      backgroundColor: this.state.isEditable ? '#ffffe0' : 'FFFFFF',
      cursor: this.state.isEditable ? 'pointer' : 'normal'
    }
    var uchiwakeList = []
    var uchiwakeListLines = [] // ページ毎の行数(セル内折返し含む)合計
    var data = this.state.data.uchiwakeList
    // 名称・仕様の文字数からセル内で折り返される行数を概算する。
    const estimateRowLines = (item) => {
      const NAME_CHARS_PER_LINE = 12
      const SPEC_CHARS_PER_LINE = 14
      const nameLen = (item.name || '').length
      const specLen = (item.specification || '').length
      const nameLines = Math.max(1, Math.ceil(nameLen / NAME_CHARS_PER_LINE))
      const specLines = Math.max(1, Math.ceil(specLen / SPEC_CHARS_PER_LINE))
      return Math.max(nameLines, specLines, 1)
    }
    let katawakuSuuryou = 0
    let daikuKingakuGoukei = 0
    let daikuNinkuGoukei = 0

    const daikuLabor = EstimationActions.getLaborSharedValues('daiku')
    let daikuLaborUnitPrice = daikuLabor.laborUnitPrice
    let daikuHoninHutanUnitPirce = daikuLabor.honninDailyHokenRyou
    let daikuKoyounushiHutanUnitPrice = daikuLabor.koyonushiDailyHokenRyou
    const kaitaiLabor = EstimationActions.getLaborSharedValues('kaitai')
    let kaitaiLaborUnitPrice = kaitaiLabor.laborUnitPrice
    let kaitaiHoninHutanUnitPirce = kaitaiLabor.honninDailyHokenRyou
    let kaitaiKoyounushiHutanUnitPrice = kaitaiLabor.koyonushiDailyHokenRyou

    let kaitaiKingakuGoukei = 0
    let kaitaiNinkuGoukei = 0

    for (let i = 0; i < data.length; i++) {
      if (data[i].isKatawakuSuuryou) {
        katawakuSuuryou += Math.round(data[i].suuryou)
      }
      let daikuNinku = data[i].daikuNinku ? data[i].daikuNinku : 0
      daikuKingakuGoukei += Math.round(daikuNinku * daikuLaborUnitPrice)
      daikuNinkuGoukei += parseFloat(daikuNinku)

      let kaitaiNinku = data[i].kaitaiNinku ? data[i].kaitaiNinku : 0
      kaitaiKingakuGoukei += Math.round(kaitaiNinku * kaitaiLaborUnitPrice)
      kaitaiNinkuGoukei += parseFloat(kaitaiNinku)
      // 行数(折返し含む)を予算とする。先頭ページは「労務費の計算」見出し等で2行分減らす。
      const lines = estimateRowLines(data[i])
      let pageOffset
      if (uchiwakeList.length === 0) {
        uchiwakeList.push([])
        uchiwakeListLines.push(0)
        pageOffset = 0
      } else {
        const lastIdx = uchiwakeList.length - 1
        const headerOffset = (lastIdx === 0) ? 2 : 0
        const budget = 20 - headerOffset
        if (uchiwakeList[lastIdx].length > 0 && uchiwakeListLines[lastIdx] + lines > budget) {
          uchiwakeList.push([])
          uchiwakeListLines.push(0)
          pageOffset = uchiwakeList.length - 1
        } else {
          pageOffset = lastIdx
        }
      }
      const kwDoubble = (uchiwakeList[pageOffset].length === 0) ? 'kw-top-double ' : ''
      const kwLast = (i === data.length - 1) ? 'kw-bottom-double ' : ''
      uchiwakeListLines[pageOffset] += lines
      uchiwakeList[pageOffset].push(
        <tr key={i}>
          <td className={kwDoubble + kwLast + 'text-left'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='name' /></td>
          <td className={kwDoubble + kwLast} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='specification' /></td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='suuryou' isNum textAlign='right' decimalPlaces='1' /></td>
          <td className={kwDoubble + kwLast + 'text-center'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='tani' /></td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='daikuBugakari' isNum decimalPlaces='1' callback={EstimationActions.updateNinku} textAlign='right' /></td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='daikuNinku' isNum decimalPlaces='1' callback={EstimationActions.updateBugakari} textAlign='right' /></td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(daikuLaborUnitPrice)}</td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(daikuLaborUnitPrice * daikuNinku)}</td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(daikuLaborUnitPrice * daikuNinku / data[i].suuryou, 1)}</td>

          <td className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='kaitaiBugakari' isNum decimalPlaces='1' callback={EstimationActions.updateNinku} textAlign='right' /></td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='kaitaiNinku' isNum decimalPlaces='1' callback={EstimationActions.updateBugakari} textAlign='right' /></td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(kaitaiLaborUnitPrice)}</td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(kaitaiLaborUnitPrice * kaitaiNinku)}</td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(kaitaiLaborUnitPrice * kaitaiNinku / data[i].suuryou, 1)}</td>

          <td className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(daikuLaborUnitPrice * daikuNinku + kaitaiLaborUnitPrice * kaitaiNinku)}</td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku((daikuLaborUnitPrice * daikuNinku + kaitaiLaborUnitPrice * kaitaiNinku) / data[i].suuryou)}</td>
        </tr>
      )
    }
    const goukeiTr = (
      <tr>

        <td className='kw-top-double text-left'>合計</td>
        <td className='kw-top-double' />
        <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='kw-top-double kw-ln' />
        <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou / daikuNinkuGoukei, 1)}</td>
        <td className='kw-top-double text-right'>{Utils.convSuuryou(daikuNinkuGoukei, 1)}</td>
        <td className='kw-top-double kw-ln' />
        <td className='kw-top-double text-right'>{Utils.convKingaku(daikuKingakuGoukei)}</td>
        <td className='kw-top-double text-right'>{Utils.convKingaku(daikuKingakuGoukei / katawakuSuuryou, 1)}</td>

        <td className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.bottom} />

        <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou / kaitaiNinkuGoukei, 1)}</td>
        <td className='kw-top-double text-right'>{Utils.convSuuryou(kaitaiNinkuGoukei, 1)}</td>
        <td className='kw-top-double kw-ln' />
        <td className='kw-top-double text-right'>{Utils.convKingaku(kaitaiKingakuGoukei)}</td>
        <td className='kw-top-double text-right'>{Utils.convKingaku(kaitaiKingakuGoukei / katawakuSuuryou, 1)}</td>

        <td className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.bottom} />

        <td className='kw-top-double text-right'>{Utils.convKingaku(daikuKingakuGoukei + kaitaiKingakuGoukei)}</td>
        <td className='kw-top-double text-right'>{Utils.convKingaku((daikuKingakuGoukei + kaitaiKingakuGoukei) / katawakuSuuryou)}</td>
      </tr>
    )
    const honninTable =
      (
        <div>
          <h5>社会保険料(本人負担分)の計算</h5>
          {headerTable}
          <table>
            <thead>
              <tr>
                <th className='kw-name' />
                <th className='kw-specific' />
                <th className='kw-person' />
                <th className='kw-unit' />

                <th className='kw-bugakari' />
                <th className='kw-ninku' />
                <th className='kw-yen-unit-price' />
                <th className='kw-yen1' />
                <th className='kw-person-unit-price' />

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.top} />

                <th className='kw-bugakari' />
                <th className='kw-ninku' />
                <th className='kw-yen-unit-price' />
                <th className='kw-yen1' />
                <th className='kw-person-unit-price' />

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.top} />

                <th className='kw-yen1' />
                <th className='kw-person-unit-price' />
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className='kw-bottom-double' rowSpan='2'>名称</th>
                <th className='kw-bottom-double' rowSpan='2' />
                <th>数量</th>

                <th />
                <th className='kw-ln' />
                <th>人工</th>
                <th>単価</th>
                <th>金額</th>
                <th>㎡単価</th>

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                <th className='kw-ln' />
                <th>人工</th>
                <th>単価</th>
                <th>金額</th>
                <th>㎡単価</th>

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                <th>金額</th>
                <th>㎡単価</th>
              </tr>
              <tr>
                <th className='kw-bottom-double'>㎡</th>
                <th className='kw-bottom-double' />

                <th className='kw-bottom-double kw-ln' />

                <th className='kw-bottom-double'>人</th>
                <th className='kw-bottom-double'>円/人</th>
                <th className='kw-bottom-double'>円</th>
                <th className='kw-bottom-double'>円/㎡</th>

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                <th className='kw-bottom-double kw-ln' />
                <th className='kw-bottom-double'>人</th>
                <th className='kw-bottom-double'>円/人</th>
                <th className='kw-bottom-double'>円</th>
                <th className='kw-bottom-double'>円/㎡</th>

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                <th className='kw-bottom-double'>円</th>
                <th className='kw-bottom-double'>円/㎡</th>
              </tr>
              <tr>
                <td className='kw-top-double'>全体</td>
                <td className='kw-top-double' />
                <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
                <td className='kw-top-double text-center' />
                <td className='kw-top-double text-center kw-ln' />
                <td className='kw-top-double text-right'>{Utils.convSuuryou(daikuNinkuGoukei, 1)}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku(daikuHoninHutanUnitPirce)}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku(Number(daikuHoninHutanUnitPirce).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1))}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku((Number(daikuHoninHutanUnitPirce).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1)) / katawakuSuuryou, 1)}</td>

                <td className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.bottom} />

                <td className='kw-top-double kw-ln' />
                <td className='kw-top-double text-right'>{Utils.convSuuryou(kaitaiNinkuGoukei, 1)}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku(kaitaiHoninHutanUnitPirce)}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku(Number(kaitaiHoninHutanUnitPirce).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1))}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku((Number(kaitaiHoninHutanUnitPirce).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1)) / katawakuSuuryou, 1)}</td>

                <td className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.bottom} />

                <td className='kw-top-double text-right'>{Utils.convKingaku(Number(daikuHoninHutanUnitPirce).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1) + Number(kaitaiHoninHutanUnitPirce).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1))}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku((Number(daikuHoninHutanUnitPirce).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1) + Number(kaitaiHoninHutanUnitPirce).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1)) / katawakuSuuryou)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    const hukuriTable =
      (
        <div>
          <h5>法定福利費の計算</h5>
          {headerTable}
          <table>
            <thead>
              <tr>
                <th className='kw-name' />
                <th className='kw-specific' />
                <th className='kw-person' />
                <th className='kw-unit' />

                <th className='kw-bugakari' />
                <th className='kw-ninku' />
                <th className='kw-yen-unit-price' />
                <th className='kw-yen1' />
                <th className='kw-person-unit-price' />

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.top} />

                <th className='kw-bugakari' />
                <th className='kw-ninku' />
                <th className='kw-yen-unit-price' />
                <th className='kw-yen1' />
                <th className='kw-person-unit-price' />

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.top} />

                <th className='kw-yen1' />
                <th className='kw-person-unit-price' />
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className='kw-bottom-double' rowSpan='2'>名称</th>
                <th className='kw-bottom-double' rowSpan='2' />
                <th>数量</th>
                <th />
                <th className='kw-ln' />
                <th>人工</th>
                <th>単価</th>
                <th>金額</th>
                <th>㎡単価</th>

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                <th className='kw-ln' />
                <th>人工</th>
                <th>単価</th>
                <th>金額</th>
                <th>㎡単価</th>

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                <th>金額</th>
                <th>㎡単価</th>
              </tr>
              <tr>
                <th className='kw-bottom-double'>㎡</th>
                <th className='kw-bottom-double' />

                <th className='kw-bottom-double kw-ln' />

                <th className='kw-bottom-double'>人</th>
                <th className='kw-bottom-double'>円/人</th>
                <th className='kw-bottom-double'>円</th>
                <th className='kw-bottom-double'>円/㎡</th>

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                <th className='kw-bottom-double kw-ln' />
                <th className='kw-bottom-double'>人</th>
                <th className='kw-bottom-double'>円/人</th>
                <th className='kw-bottom-double'>円</th>
                <th className='kw-bottom-double'>円/㎡</th>

                <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                <th className='kw-bottom-double'>円</th>
                <th className='kw-bottom-double'>円/㎡</th>
              </tr>
              <tr>
                <td className='kw-top-double'>全体</td>
                <td className='kw-top-double' />
                <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
                <td className='kw-top-double text-center' />

                <td className='kw-top-double text-center kw-ln' />
                <td className='kw-top-double text-right'>{Utils.convSuuryou(daikuNinkuGoukei, 1)}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku(daikuKoyounushiHutanUnitPrice)}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku(Number(daikuKoyounushiHutanUnitPrice).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1))}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku((Number(daikuKoyounushiHutanUnitPrice).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1)) / katawakuSuuryou, 1)}</td>

                <td className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.bottom} />

                <td className='kw-top-double kw-ln' />
                <td className='kw-top-double text-right'>{Utils.convSuuryou(kaitaiNinkuGoukei, 1)}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku(kaitaiKoyounushiHutanUnitPrice)}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku(Number(kaitaiKoyounushiHutanUnitPrice).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1))}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku((Number(kaitaiKoyounushiHutanUnitPrice).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1)) / katawakuSuuryou, 1)}</td>

                <td className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.bottom} />

                <td className='kw-top-double text-right'>{Utils.convKingaku(Number(daikuKoyounushiHutanUnitPrice).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1) + Number(kaitaiKoyounushiHutanUnitPrice).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1))}</td>
                <td className='kw-top-double text-right'>{Utils.convKingaku((Number(daikuKoyounushiHutanUnitPrice).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1) + Number(kaitaiKoyounushiHutanUnitPrice).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1)) / katawakuSuuryou)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    const pages = []
    let isGoukeiPrinted = false
    let isHonninPrinted = false
    let isHukuriPrinted = false
    for (let i = 0; i < uchiwakeList.length; i++) {
      const uchiwakeHeader = (i === 0) ? <h5>労務費の計算</h5> : []
      const minusForHeader = (i === 0) ? -2 : 0
      if (i === uchiwakeList.length - 1) {
        // 行数ベースで判定(セル内折返し含む)
        if (uchiwakeListLines[i] <= (20 + minusForHeader)) {
          isGoukeiPrinted = true
        }
        // 社会保険料(本人負担分)と法定福利費は同じページに配置するため、
        // 両方が収まる場合のみ uchiwake ページに含める(片方だけ印字されないようにする)。
        if (uchiwakeListLines[i] <= (11 + minusForHeader)) {
          isHonninPrinted = true
          isHukuriPrinted = true
        }
      }
      const uchiwakeFooter = isGoukeiPrinted ? goukeiTr : []
      const honninCategory = isHonninPrinted ? honninTable : []
      const hukuriCategory = isHukuriPrinted ? hukuriTable : []
      pages.push(
        <div key={'page' + i}>
          <article className='kw-katawaku-art'>

            <section className='kw-print-page kw-print-page-area'>
              <div className='kw-container'>

                <div className='kw-laborview'>
                  {uchiwakeHeader}
                  {headerTable}
                  <table>
                    <thead>
                      <tr>
                        <th className='kw-name' />
                        <th className='kw-specific' />
                        <th className='kw-person' />
                        <th className='kw-unit' />

                        <th className='kw-bugakari' />
                        <th className='kw-ninku' />
                        <th className='kw-yen-unit-price' />
                        <th className='kw-yen1' />
                        <th className='kw-person-unit-price' />

                        <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.top} />

                        <th className='kw-bugakari' />
                        <th className='kw-ninku' />
                        <th className='kw-yen-unit-price' />
                        <th className='kw-yen1' />
                        <th className='kw-person-unit-price' />

                        <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.top} />

                        <th className='kw-yen1' />
                        <th className='kw-person-unit-price' />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th className='kw-bottom-double' rowSpan='2'>名称</th>
                        <th className='kw-bottom-double' rowSpan='2'>仕様</th>
                        <th className='kw-bottom-double' rowSpan='2'>数量</th>
                        <th className='kw-bottom-double' rowSpan='2'>単位</th>

                        <th>歩掛</th>
                        <th>人工</th>
                        <th>人件費</th>
                        <th>金額</th>
                        <th>単価</th>

                        <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                        <th>歩掛</th>
                        <th>人工</th>
                        <th>人件費</th>
                        <th>金額</th>
                        <th>㎡単価</th>

                        <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                        <th>合計金額</th>
                        <th>単価</th>
                      </tr>
                      <tr>
                        <th className='kw-bottom-double'>数量/人</th>
                        <th className='kw-bottom-double'>人</th>
                        <th className='kw-bottom-double'>円/人</th>
                        <th className='kw-bottom-double'>円</th>
                        <th className='kw-bottom-double'>円/数量</th>

                        <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                        <th className='kw-bottom-double'>数量/人</th>
                        <th className='kw-bottom-double'>人</th>
                        <th className='kw-bottom-double'>円/人</th>
                        <th className='kw-bottom-double'>円</th>
                        <th className='kw-bottom-double'>円/数量</th>

                        <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

                        <th className='kw-bottom-double'>円</th>
                        <th className='kw-bottom-double'>円/数量</th>
                      </tr>
                      {uchiwakeList[i]}
                      {uchiwakeFooter}
                    </tbody>
                  </table>

                  {honninCategory}
                  {hukuriCategory}
                </div>

              </div>
            </section>

          </article>
        </div>
      )
    }
    if (!isGoukeiPrinted || !isHonninPrinted || !isHukuriPrinted) {
      const uchiwakeTable = (!isGoukeiPrinted) ? (
        <table>
          <thead>
            <tr>
              <th className='kw-name' />
              <th className='kw-specific' />
              <th className='kw-person' />
              <th className='kw-unit' />

              <th className='kw-bugakari' />
              <th className='kw-ninku' />
              <th className='kw-yen-unit-price' />
              <th className='kw-yen1' />
              <th className='kw-person-unit-price' />

              <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.top} />

              <th className='kw-bugakari' />
              <th className='kw-ninku' />
              <th className='kw-yen-unit-price' />
              <th className='kw-yen1' />
              <th className='kw-person-unit-price' />

              <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.top} />

              <th className='kw-yen1' />
              <th className='kw-person-unit-price' />
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className='kw-bottom-double' rowSpan='2'>名称</th>
              <th className='kw-bottom-double' rowSpan='2'>仕様</th>
              <th className='kw-bottom-double' rowSpan='2'>数量</th>
              <th className='kw-bottom-double' rowSpan='2'>単位</th>

              <th>歩掛</th>
              <th>人工</th>
              <th>人件費</th>
              <th>金額</th>
              <th>㎡単価</th>

              <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

              <th>歩掛</th>
              <th>人工</th>
              <th>人件費</th>
              <th>金額</th>
              <th>㎡単価</th>

              <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

              <th>合計金額</th>
              <th>単価</th>
            </tr>
            <tr>
              <th>数量/人</th>
              <th>人</th>
              <th>円/人</th>
              <th>円</th>
              <th>円/数量</th>

              <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

              <th>数量/人</th>
              <th>人</th>
              <th>円/人</th>
              <th>円</th>
              <th>円/数量</th>

              <th className='kw-kuuhaku' style={StyleCompanyUser.printPageArea.laborview.kuuhaku.normal} />

              <th>円</th>
              <th>円/数量</th>
            </tr>
            {goukeiTr}
          </tbody>
        </table>
      ) : ''
      const honninCategory = !isHonninPrinted ? honninTable : []
      const hukuriCategory = !isHukuriPrinted ? hukuriTable : []
      pages.push(
        <div key='lastPage'>
          <article className='kw-katawaku-art'>

            <section className='kw-print-page kw-print-page-area'>
              <div className='kw-container'>

                <div className='kw-laborview'>
                  {uchiwakeTable}
                  {honninCategory}
                  {hukuriCategory}
                </div>

              </div>
            </section>

          </article>
        </div>
      )
    }
    return pages
  }
}

export default LaborCostPrintTab



// WEBPACK FOOTER //
// ./src/company_user/print/LaborCostPrintTab.js